import { buildProps } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue-demi' // test vue-demi
import type ButtonGroup from './button-group.vue'

export const buttonGroupProps = buildProps({
  direction: {
    type: String,
    values: ['horizontal', 'vertical'],
    default: 'horizontal',
  },
  reverse: Boolean,
  block: Boolean,
})

export type ButtonGroupProps = ExtractPropTypes<typeof buttonGroupProps>
export type ButtonInstance = InstanceType<typeof ButtonGroup>
